import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const magnifying_glass_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M9,3.4997 C12.038,3.4997 14.5,5.9627 14.5,8.9997 C14.5,12.0377 12.038,14.4997 9,14.4997
        C5.962,14.4997 3.5,12.0377 3.5,8.9997 C3.5,5.9627 5.962,3.4997 9,3.4997 Z M20,19.9997 L12.889,12.8887"
      />
    </svg>
  );
};
